module.exports = __webpack_public_path__ + "static/media/intro.c3c29048.wav";